'use strict';

angular
  .module('appSettingTutorial')
  .component('appSettingTutorial', {
    template: require('./tutorial.template.html'),
    controller: ['$rootScope', '$resource', '$translate', 'AuthService', 'envService', 'Upload',
      function AppSettingTutorialController($rootScope, $resource, $translate, AuthService, envService, Upload) {
        const APIURL = envService.read('apiUrl');

        $rootScope.mainmenu = 'appSetting';
        $rootScope.menu = 'tutorial';

        this.doLogout = $rootScope.gLogout;
        this.loginMember = AuthService.loginMember();
        this.isLevel2Auth = AuthService.canEditAppSettings();
        this.saving = false;
        this.countries = ['TH', 'KR', 'JP'];
        this.textLocales = ['en', 'th', 'ko', 'ja'];
        const memberCountry = (this.loginMember && this.loginMember.COUNTRY_CODE)
          ? String(this.loginMember.COUNTRY_CODE).toUpperCase()
          : 'TH';
        this.country = this.countries.indexOf(memberCountry) >= 0 ? memberCountry : 'TH';

        this._resolveTextLang = () => {
          let saved = null;
          try { saved = window.localStorage.getItem('omgAdminLang'); } catch (e) { saved = null; }
          const raw = String(
            saved
            || $translate.use()
            || $translate.proposedLanguage()
            || 'en'
          ).slice(0, 2).toLowerCase();
          if (raw === 'jp') return 'ja';
          if (this.textLocales.indexOf(raw) >= 0) return raw;
          return 'en';
        };
        this.textLang = this._resolveTextLang();
        this.textLangLabel = () => {
          const map = { en: 'EN', th: 'TH', ko: 'KO', ja: 'JA' };
          return map[this.textLang] || String(this.textLang || '').toUpperCase();
        };
        $rootScope.$on('$translateChangeSuccess', () => {
          // Keep previous language's URL list, then switch editor to new top-right lang.
          this.applyIntroTextToModel();
          this.textLang = this._resolveTextLang();
          this.syncIntroTextFromModel();
          if (this.isLevel2Auth) {
            this.fillDefaults(false);
          }
        });

        this._emptyIntroByLocale = () => {
          const out = {};
          this.textLocales.forEach((lang) => {
            out[lang] = [];
          });
          return out;
        };

        this._normalizeRow = (raw) => {
          const src = raw || {};
          const intro = this._emptyIntroByLocale();
          const srcIntro = src.intro_images || {};
          this.textLocales.forEach((lang) => {
            intro[lang] = Array.isArray(srcIntro[lang])
              ? srcIntro[lang].slice()
              : [];
          });
          return {
            coupon_image_url: src.coupon_image_url || '',
            texts: src.texts || {},
            intro_images: intro,
          };
        };

        this.rows = {
          TH: this._normalizeRow(null),
          KR: this._normalizeRow(null),
          JP: this._normalizeRow(null),
        };
        this.tutorialDefaults = {
          TH: this._emptyIntroByLocale(),
          KR: this._emptyIntroByLocale(),
          JP: this._emptyIntroByLocale(),
        };

        this.currentIntro = () => {
          const row = this.rows[this.country];
          if (!row.intro_images[this.textLang]) {
            row.intro_images[this.textLang] = [];
          }
          return row.intro_images[this.textLang];
        };

        this.introUrlsText = '';
        this.syncIntroTextFromModel = () => {
          this.introUrlsText = this.currentIntro().join('\n');
        };
        this.applyIntroTextToModel = () => {
          const lines = String(this.introUrlsText || '')
            .split(/\n+/)
            .map((s) => s.trim())
            .filter(Boolean);
          this.rows[this.country].intro_images[this.textLang] = lines;
        };

        this.removeIntroAt = (index) => {
          this.applyIntroTextToModel();
          const list = this.currentIntro();
          if (index < 0 || index >= list.length) return;
          list.splice(index, 1);
          this.syncIntroTextFromModel();
        };

        this.fillDefaults = (force) => {
          const defaults = ((this.tutorialDefaults[this.country] || {})[this.textLang]) || [];
          if (!defaults.length) return;
          this.applyIntroTextToModel();
          const cur = this.currentIntro();
          if (force || !cur.length) {
            this.rows[this.country].intro_images[this.textLang] = defaults.slice();
            this.syncIntroTextFromModel();
          }
        };

        this.uploadIntroImage = (files) => {
          if (!files || !files.length || !this.isLevel2Auth) return;
          Upload.upload({
            url: `${APIURL}/admin/file/intro`,
            file: files[0],
          }).success((data) => {
            if (data && data.url) {
              this.applyIntroTextToModel();
              this.currentIntro().push(data.url);
              this.syncIntroTextFromModel();
            }
          }).error(() => {
            alert($translate.instant('알수 없는 에러 입니다.'));
          });
        };

        this.load = () => {
          $resource(`${APIURL}/admin/services/apps/settings`)
            .get()
            .$promise
            .then((data) => {
              const defaults = (data && data.tutorial_defaults) || {};
              this.countries.forEach((code) => {
                this.tutorialDefaults[code] = Object.assign(
                  this._emptyIntroByLocale(),
                  defaults[code] || {}
                );
              });
              const welcome = (data && data.welcome) || {};
              this.countries.forEach((code) => {
                this.rows[code] = this._normalizeRow(welcome[code]);
              });
              this.syncIntroTextFromModel();
              if (this.isLevel2Auth) {
                this.fillDefaults(false);
              }
            })
            .catch((err) => {
              if (err.data && err.data.msg) alert(err.data.msg);
              else alert($translate.instant('알수 없는 에러 입니다.'));
            });
        };

        this.save = () => {
          if (!this.isLevel2Auth) return;
          if (!confirm($translate.instant('튜토리얼 설정을 저장하시겠습니까?'))) return;
          this.applyIntroTextToModel();
          this.saving = true;
          // Preserve coupon texts/images; only update intro_images per country.
          const welcome = {};
          this.countries.forEach((code) => {
            const row = this.rows[code];
            welcome[code] = {
              coupon_image_url: row.coupon_image_url || '',
              texts: row.texts || {},
              intro_images: row.intro_images,
            };
          });
          const Res = $resource(`${APIURL}/admin/services/apps/settings`, {}, {
            update: { method: 'PUT' },
          });
          Res.update({ welcome })
            .$promise
            .then((data) => {
              const saved = (data && data.welcome) || welcome;
              this.countries.forEach((code) => {
                this.rows[code] = this._normalizeRow(saved[code]);
              });
              this.syncIntroTextFromModel();
              alert($translate.instant('수정되었습니다.'));
            })
            .catch((err) => {
              if (err.data && err.data.msg) alert(err.data.msg);
              else alert($translate.instant('알수 없는 에러 입니다.'));
            })
            .finally(() => {
              this.saving = false;
            });
        };

        this.load();
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/app-setting/tutorial/tutorial.component.js